import { useMemo } from 'react';

import { Row } from 'UIPackage/FormModule/components/Row';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { KnmCollapse } from 'KnmPackage/MainModule/components/KnmCollapse';
import { IKnmHistoryItemChanges } from 'KnmPackage/KnmHistoriesModule/interfaces/IKnmHistoryItemChanges';
import { REQUIRED_ERROR } from 'CorePackage/MainModule/constants/validationErrors';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import { PublishRulesFormAdditionalSettings } from './PublishRulesFormAdditionalSettings';
import { PublishRulesHistory } from './PublishRulesHistory';
import styles from './PublishRulesKnmUnscheduledFormBlock.module.scss';
import { PublishRulesKnmUnscheduledFormBlockNamesEnum } from '../enums/publishRulesKnmUnscheduledFormBlockNamesEnum';
import { getPublishDeadlineOptions } from '../common/getPublishDeadlineOptions';

interface IPublishRulesKnmUnscheduledFormBlockProps {
  blockTitle: string;
  blockSubtitle: string;
  isHaveSavedSettings?: boolean;
  historyChanges?: IKnmHistoryItemChanges[];
  blockName: PublishRulesKnmUnscheduledFormBlockNamesEnum;
  onClose?: () => void;
  knmStatusesSelectOptions?: ISelectOption[];
  reasonTypesSelectOptions?: ISelectOption[];
}

const PublishRulesKnmUnscheduledFormBlockWithoutStore = ({
  blockTitle,
  blockSubtitle,
  isHaveSavedSettings,
  historyChanges,
  blockName,
  onClose,
  knmStatusesSelectOptions,
  reasonTypesSelectOptions,
}: IPublishRulesKnmUnscheduledFormBlockProps) => {
  const publishDeadlineSelectOptions = useMemo(() => getPublishDeadlineOptions(), []);

  return (
    <KnmCollapse
      theme="fields"
      title={
        <span>
          {blockTitle} / <span className={styles.HeaderSubtext}>{blockSubtitle}</span>
        </span>
      }
      onClose={isHaveSavedSettings ? onClose : undefined}
      openByDefault
      isNew={!isHaveSavedSettings}
    >
      <>
        <FieldBlock label="Основное правило">
          <Row notWrap>
            <FieldBlock label="По достижении статуса" placementLabel="left" color="black" margin="right">
              <SelectInputField
                className="shared-row-field"
                name={`${blockName}.uponAttainingStatus`}
                isMulti
                options={knmStatusesSelectOptions}
                placeholder="Выберите статус"
                validate={makeRequired(REQUIRED_ERROR)}
              />
            </FieldBlock>
            <FieldBlock label="Срок публикации" placementLabel="left" color="black">
              <SelectInputField
                className="shared-row-field"
                name={`${blockName}.publishDeadline`}
                placeholder="Выберите срок"
                options={publishDeadlineSelectOptions}
                validate={makeRequired(REQUIRED_ERROR)}
              />
            </FieldBlock>
          </Row>
        </FieldBlock>
        <PublishRulesFormAdditionalSettings
          blockName={blockName}
          showDeadline
          showDate={false}
          statusesSelectOptions={knmStatusesSelectOptions}
          reasonTypesSelectOptions={reasonTypesSelectOptions}
        />
        {historyChanges && (
          <Row>
            <PublishRulesHistory historyChanges={historyChanges} />
          </Row>
        )}
      </>
    </KnmCollapse>
  );
};

export const PublishRulesKnmUnscheduledFormBlock = PublishRulesKnmUnscheduledFormBlockWithoutStore;
